import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import SelectField from 'src/common/formFields/SelectField';
import InputField from 'src/common/formFields/InputField';
import DatePickerField from 'src/common/formFields/DatePickerField';
import {
  TRANSACTION_DATE_PICKER_POPPER_SX,
  TRANSACTION_STYLE_COLORS
} from '../transactionStyleTokens';

export default function ExternalTransactionForm({ formField, initialValues, requiredHintText }) {
  const {
    siteId,
    quantity,
    unitPrice,
    amount,
    vehicleNumber,
    dateTime,
    odometerEntry
  } = formField;
  const { allSites } = useSelector((state) => state.sites);
  const formik = useFormikContext();
  const amountTouchedRef = useRef(false);

  useEffect(() => {
    if (amountTouchedRef.current) return;
    const qty = Number(formik.values?.[quantity.name]);
    const price = Number(formik.values?.[unitPrice.name]);
    if (Number.isFinite(qty) && Number.isFinite(price) && qty >= 0 && price >= 0) {
      const computedAmount = Number((qty * price).toFixed(2));
      formik.setFieldValue(amount.name, computedAmount.toString());
    }
  }, [formik.values?.[quantity.name], formik.values?.[unitPrice.name]]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <SelectField
          name={siteId.name}
          label={`${siteId.label} *`}
          data={allSites}
          disabled={!!initialValues}
          required
          requiredHintText={requiredHintText}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField name={vehicleNumber.name} label={vehicleNumber.label} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField name={quantity.name} label={`${quantity.label} *`} required requiredHintText={requiredHintText} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField name={unitPrice.name} label={`${unitPrice.label} *`} required requiredHintText={requiredHintText} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField
          name={amount.name}
          label={`${amount.label} *`}
          required
          requiredHintText={requiredHintText}
          fullWidth
          onChange={(e) => {
            amountTouchedRef.current = true;
            formik.handleChange(e);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputField name={odometerEntry.name} label={`${odometerEntry.label} *`} required requiredHintText={requiredHintText} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DatePickerField
          name={dateTime.name}
          label={`${dateTime.label} *`}
          required
          requiredHintText={requiredHintText}
          pickerIconColor={TRANSACTION_STYLE_COLORS.primary}
          pickerPopperSx={TRANSACTION_DATE_PICKER_POPPER_SX}
          fullWidth
        />
      </Grid>
    </Grid>
  );
}

ExternalTransactionForm.propTypes = {
  formField: PropTypes.object.isRequired,
  initialValues: PropTypes.object,
  requiredHintText: PropTypes.string
};
